import { render, staticRenderFns } from "./AppointmentInvoice.vue?vue&type=template&id=048ec1b8&scoped=true&"
import script from "./AppointmentInvoice.vue?vue&type=script&lang=js&"
export * from "./AppointmentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentInvoice.vue?vue&type=style&index=0&id=048ec1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ec1b8",
  null
  
)

export default component.exports